import { createContext, Dispatch, SetStateAction } from "react"

import { OCBAppViews } from "@/entities/app/ocb/ocb.types"


const ocbViewsContext = createContext<[Partial<OCBAppViews>, Dispatch<SetStateAction<Partial<OCBAppViews>>>] | null>(null)
export default ocbViewsContext
